import React from 'react';
import { Col, Container, Row } from "react-bootstrap";
import logo from '../../assets/images/logo.png'
import LoginForm from "./SubComponent/LoginForm";
import { ToastContainer } from "react-toastify";

function LoginComponent(props) {
    return (
        <>
            <section class="memberLoginSec">
                <Container >
                    <Row className="justify-content-center ">

                        {/*login form*/}
                        <Col className="text-center align-items-center " md={4}>
                            <div class="loginBox">
                                <img className="loginLogo" src={logo} />

                                <LoginForm />
                            </div>

                        </Col>
                    </Row>
                    {/*toast container*/}
                    <ToastContainer />
                </Container>
            </section>
        </>
    );
}

export default LoginComponent;